import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";


import { useState } from "react"; // Importing useState hook

import Index from "./component/index/Index";
import Contact from "./component/contact/Contact";
import Login from "./component/Login/Login";
import About from "./component/About_us/About";
import Donate from "./component/donate/Donate";
import Program from "./component/Program/Program";
import Exam from "./component/Exam/Exam";
import Certificate from "./component/Certificate/Certificate";
import AOS from "aos";
import "aos/dist/aos.css";
import Signin from "./component/Login/Signin";
import TrainingProgram from "./component/Program/TrainingProgram";
import StudentsActivity from "./component/Program/StudentsActivity";
import AgricultureProgram from "./component/Program/AgricultureProgram";
import Medical from "./component/Program/Medical";
import SportsActivities from "./component/Program/SportsActivities";
import Header from "./component/Header/Header";
import Admin from "./component/Adminpage/Admin";
import Adminadd from "./component/Adminpage/Adminadd";
import Adminform from "./component/Adminpage/Adminform";
import Institution from "./component/Institution/Institution";
import InstitutionForm from "./component/Institution/InstitutionForm";
import DonateAdd from "./component/donate/DonateAdd";
import DonateaddQr from "./component/donate/DonateaddQr";
import Donate_account from "./component/donate/Donate_account";
import Donate_account_Add from "./component/donate/Donate_account_Add";
import InstitutionLogin from "./component/Institution/InstitutionLogin";
import Studentadd from "./component/student/Studentadd";
import Studentform from "./component/student/Studentform";
import StudentLogin from "./component/student/StudentLogin";
import Privacypolicy from "./component/Privacy/Privacypolicy";
import Terms from "./component/Privacy/Terms";
import Refund from "./component/Privacy/Refund";
import Tailoring from "./component/Tailoring/Tailoring";
import Adddetails from "./component/ourdetails/Adddetails";
import ApproveCertificate from "./component/Tailoring/ApproveCertificate";
import PaymentSuccess from "./component/donate/PaymentSuccess";
import StudentExam from "./component/Exam/StudentExam";
import StudentProfile from "./component/student/StudentProfile";
import AdminExam from "./component/Exam/AdminExamApply";
import StudExamDetails from "./component/Exam/studExamdetails";
import StudentidView from "./component/student/StudentidView";
import AllApplications from "./component/Exam/AllApplications";
import Allstudent from "./component/Exam/Allstudent";
import Apppalytrialexam from "./component/Exam/Apppalytrialexam";
import AllQuestions from "./component/Questions/AllQuestions";
import Examschedule from "./component/Exam/Examschedule";
import ExamPage from "./component/Exam/ExamPage";
import PracticeExam from "./component/Exam/PracticeExam";
import Wallet from "./component/Wallet/Wallet";
import WalletExam from "./component/Exam/WalletExam";
import { useEffect } from "react";
import Exammarks from "./component/Exam/Exammarks";
import Adminpage from "./component/Adminpage/Adminpage";
import WalletPage from "./component/Wallet/WalletPage";
import Meetingpage from "./page/Meetingpage";
import Meetingticket from "./page/Meetingticket";
import Viewmeatingpage from "./page/Viewmeatingpage";
import Meetingpending from "./page/Meetingpending";
import Examresult from "./component/Exam/Examresult";
import Interview from "./page/Interview";
import Viewinterview from "./page/Viewinterview";
import Examranklist from "./component/Adminpage/Examranklist";
import Examcertificate from "./component/student/Examcertificate";
import SectionSelector from "./component/Adminpage/SectionSelector";
import FundRequestPage from "./component/Wallet/FundRequestPage";


AOS.init();

function App() {
  const [login, setLogin] = useState(false); // Manage login state





   useEffect(() => {
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;

      console.log('✅ App can be installed');
      // You can now show a custom install button and call `deferredPrompt.prompt()` on click
      window.deferredPrompt = deferredPrompt; // store globally if needed
    });
  }, []);
  return (
    <div className="App">
      {/* <Router> */}
        {/* <Header login={login} setLogin={setLogin} />  Pass login state and setLogin function to Header */}

        <Routes>
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login setLogin={setLogin} />} />
          {/* Pass setLogin to Login */}
          <Route path="/" element={<Index />} />
          <Route path="/aboutus" element={<About />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/program" element={<Program />} />
          <Route path="/certification" element={<Certificate />} />
          <Route path="/exam" element={<Exam />} />
          <Route path="/signin" element={<Signin setLogin={setLogin} />} />
          <Route path="/signin/:referralId" element={<Signin setLogin={setLogin} />} />
          {/* Pass setLogin to Signin */}
          <Route path="/trainingprogram" element={<TrainingProgram />} />
          <Route path="/studentsactivity" element={<StudentsActivity />} />
          <Route path="/agricultureprogram" element={<AgricultureProgram />} />
          <Route path="/medical" element={<Medical />} />
          <Route path="/Sportsactivities" element={<SportsActivities />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/adminadd" element={<Adminadd />} />
          <Route path="adminform" element={<Adminform />}></Route>
          <Route path="/institution" element={<Institution />}></Route>
          <Route path="/institutionform" element={<InstitutionForm />}></Route>
          <Route path="/donateadd" element={<DonateAdd />}></Route>
          <Route path="/donateaddqr" element={<DonateaddQr />}></Route>
          <Route path="/donate_account" element={<Donate_account />}></Route>
          <Route path="/donate_account_add" element={<Donate_account_Add />}></Route>
          <Route path="/institutionlogin"  element={<InstitutionLogin />}></Route>
          <Route path="/studentadd" element={<Studentadd />}></Route>
          <Route path="/studentform" element={<Studentform />}></Route>
          <Route path="/studentlogin" element={<StudentLogin />}></Route>
          <Route path="/privacypolicy" element={<Privacypolicy />}></Route>
          <Route path="/terms" element={<Terms />}></Route>
          <Route path="/refund" element={<Refund/>}></Route>
          <Route path="/tailoring" element={<Tailoring/>}></Route>
          <Route path="/addourdetails" element={<Adddetails/>}></Route>
          <Route path="/approvecertificate" element={<ApproveCertificate/>}></Route>
          <Route path="/payment-success" element={<PaymentSuccess/>}></Route>
          <Route path="/studentexam" element={<StudentExam/>}></Route>
          <Route path="/profile" element={<StudentProfile/>}></Route>
          <Route path="/applyexam" element={<AdminExam/>}></Route>
          <Route path="/stddetails" element={<StudExamDetails/>}></Route>
          <Route path="/studentid" element={<StudentidView/>}></Route>
          <Route path="/allapplications" element={<AllApplications/>}></Route>
          <Route path="/allstudent" element={<Allstudent/>}></Route>
           <Route path="/allquestions" element={<AllQuestions/>}></Route>
            <Route path="/examschedule" element={<Examschedule/>}></Route>
             <Route path="/exampage" element={<ExamPage/>}></Route>
             <Route path="/praticeexam" element={<PracticeExam/>}></Route>
             <Route path="/wallet" element={<Wallet/>}></Route>
              <Route path="/walletexam" element={<WalletExam/>}></Route>
             <Route path="/exammarks" element={<Exammarks/>}></Route>
               <Route path="/adminpage" element={<Adminpage/>}></Route>
                <Route path="/walletpage" element={<WalletPage/>}></Route>
                 <Route path="/meetingregistration" element={<Meetingpage/>}></Route>

                  <Route path="/meetingticket" element={<Meetingticket/>}></Route>
                   <Route path="/viewmeeting" element={<Viewmeatingpage/>}></Route>
                    <Route path="/meetingpending" element={<Meetingpending/>}></Route>
                      <Route path="/contact_us" element={<Interview/>}></Route>
                     <Route path="/examresult" element={<Examresult/>}></Route>
                     <Route path="/viewinterview" element={<Viewinterview/>}></Route>
                       <Route path="/exam_rank_list" element={<Examranklist/>}></Route>
                       <Route path="/examcertificate" element={<Examcertificate/>}></Route>
                        
                         <Route path="/fund-request-page" element={<FundRequestPage/>}></Route>
                         <Route path="/exam_rank_list_section" element={<SectionSelector/>}></Route>
           {/* <Route path="/apppalytrialexam" element={<Apppalytrialexam/>}></Route> */}
        </Routes>
      {/* </Router> */}
    </div>
  );
}

export default App;
